import React, { useEffect, useState } from "react";
import api from "@api";
import { NavLink, useParams } from "react-router-dom";
import "./DirectoryLeagueTeam.css";

function DirectoryLeagueTeam() {
 const { leagueNameAndId, seasonsLeagueTeamId } = useParams();
 const directoryLeagueId = leagueNameAndId?.split("-").pop();

 const [league, setLeague] = useState(null);
 const [teamPage, setTeamPage] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
  const fetchLeague = async () => {
   try {
    const res = await api.get(`/api/directory/leagues/${directoryLeagueId}`);
    setLeague(res.data);
   } catch (err) {
    console.error("Failed to fetch league", err);
   }
  };

  const fetchTeam = async () => {
   try {
    const res = await api.get(
     `/api/directory/leagues/${directoryLeagueId}/teams/${seasonsLeagueTeamId}`
    );
    setTeamPage(res.data);
   } catch (err) {
    console.error("Failed to fetch directory team page", err);
   } finally {
    setLoading(false);
   }
  };

  fetchLeague();
  fetchTeam();
 }, [directoryLeagueId, seasonsLeagueTeamId]);

 const team = teamPage?.team;
 const roster = teamPage?.roster || [];
 const games = teamPage?.games || [];
 const formatDate = (date) => {
  if (!date) return "Date TBD";

  return new Date(`${date}T00:00:00`).toLocaleDateString("en-US", {
   month: "numeric",
   day: "numeric",
   year: "2-digit",
  });
 };

 const formatTime = (time) => {
  if (!time) return "Time TBD";

  const [hourRaw, minuteRaw] = time.split(":");
  const hour = Number(hourRaw);
  const minute = minuteRaw || "00";

  if (!Number.isFinite(hour)) return time;

  const suffix = hour >= 12 ? "PM" : "AM";
  const displayHour = hour % 12 || 12;

  return `${displayHour}:${minute} ${suffix}`;
 };

 return (
  <div className="league-profile-page">
   <div className="league-profile-container">
    <div className="league-profile-public-tabs">
     <NavLink end to={`/leagues/${leagueNameAndId}`}>
      Overview
     </NavLink>

     <NavLink to={`/leagues/${leagueNameAndId}/schedule`}>
      Schedule
     </NavLink>

         <NavLink to={`/leagues/${leagueNameAndId}/standings`}>
           Standings
         </NavLink>
         <NavLink to={`/leagues/${leagueNameAndId}/players`}>
           Players
         </NavLink>
    </div>

    <div className="league-profile-card directory-team-card">
     {teamPage?.locked ? (
      <div className="directory-team-empty">
       Team pages are available with League Tools.
      </div>
     ) : (
      <>
        <div className="directory-team-header">
         <div>

          <h1 className="directory-team-title">
           {team?.team?.name || team?.name || "Team"}
          </h1>
         </div>
        </div>

       <div className="directory-team-grid">
        <div className="directory-team-section">
         <h2>Roster</h2>

         {roster.length > 0 ? (
          <div className="directory-team-list">
                       {roster.map((player) => (
                         <NavLink
                           key={player.id}
                           to={`/leagues/${leagueNameAndId}/players/${player.id}`}
                           className="directory-team-row"
                         >
                           {`${player.player?.firstName || ""} ${player.player?.lastName || ""}`.trim() || "Player"}
                         </NavLink>
                       ))}
          </div>
         ) : (
          <div className="directory-team-empty">
           No players have been added yet.
          </div>
         )}
        </div>

        <div className="directory-team-section">
         <h2>Games</h2>

         {games.length > 0 ? (
          <div className="directory-team-list">
            {games.map((game) => {
             const homeTeamName =
              game.homeTeam?.team?.name ||
              game.home_team?.team?.name ||
              "Team TBD";

             const awayTeamName =
              game.awayTeam?.team?.name ||
              game.away_team?.team?.name ||
              "Team TBD";

             const isHome = Number(game.home_team_id) === Number(seasonsLeagueTeamId);
             const opponent = isHome ? awayTeamName : homeTeamName;

              const homeScore = Number(game.score_home || 0);
              const awayScore = Number(game.score_away || 0);
              const hasResult = homeScore > 0 || awayScore > 0;

              const gameDate = game.date ? new Date(`${game.date}T23:59:59`) : null;
              const isPastGame = gameDate && gameDate < new Date();

              const resultLabel = hasResult
                ? `${homeScore} - ${awayScore}`
                : isPastGame
                  ? "Result pending"
                  : "Upcoming";

              const resultClass = hasResult
                ? "is-completed"
                : isPastGame
                  ? "is-pending"
                  : "is-upcoming";

             return (
               <NavLink
                 key={game.id}
                 className="directory-team-game-row"
                 to={`/leagues/${leagueNameAndId}/games/${game.id}`}
               >
               <div>
                <div className="directory-team-game-main">
                 {isHome ? "vs" : "at"} {opponent}
                </div>

                <div className="directory-team-game-meta">
                 {formatDate(game.date)} · {formatTime(game.time)}
                 {game.location ? ` · ${game.location}` : ""}
                </div>
               </div>

               <span
                   className={`directory-team-game-result ${resultClass}`}
               >
                {resultLabel}
               </span>
              </NavLink>
             );
            })}
          </div>
         ) : (
          <div className="directory-team-empty">
           No games found for this team yet.
          </div>
         )}
        </div>
       </div>
      </>
     )}
    </div>
   </div>
  </div>
 );
}

export default DirectoryLeagueTeam;